import { ChangeDetectorRef, Component } from '@angular/core';
// import { SidebarComponent } from '../../components/sidebar/sidebar.component';
// import { FooterComponent } from '../../components/footer/footer.component';
// import { HeaderComponent } from '../../components/header/header.component';
import { GlobalService } from '../../_services/global.service';
import { BusyService } from '../../_services/busy.service';
import { DatasearchService } from '../../_services/datasearch.service';
import { NewsBannerComponent } from '../../components/news-banner/news-banner.component';
import { NewsCategoryComponent } from '../../components/news-category/news-category.component';
import { NgIf, NgClass } from '@angular/common';
import { RecentNewsComponent } from '../../components/recent-news/recent-news.component';
import { ipdUpdatesHeaderComponent } from '../ipd-updates-header/ipd-updates-header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';

@Component({
  selector: 'app-patent',
  standalone: true,
  imports: [
    NewsBannerComponent,
    NewsCategoryComponent,
    NgIf,
    RecentNewsComponent,
    ipdUpdatesHeaderComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    NgClass,
  ],
  templateUrl: './patent.component.html',
  styleUrl: './patent.component.scss',
})
export class PatentComponent {
  filePath = 'https://adminbackend.chemrobotics.com/uploads/news_images/';
  newsList: any[] = [];
  recentNewsList: any[] = [];
  newsBannerData: any = [];
  newsCategoryData: any = {};
  showNews = false;
  showAllButton = true;
  showCategory = false;
  databaseId: string = '';
  databaseName: string = 'AgroPat Discovery';
  heading = '';
  toggle_sidebar = false;

  constructor(
    private globalService: GlobalService,
    private datasearch: DatasearchService,
    private busyService: BusyService,
    private cdref: ChangeDetectorRef
  ) { }

  ngOnInit() {
    // Send menu index after a small delay to ensure sidebar is initialized
    setTimeout(() => {
      this.globalService.sendMenuIndex(1); // 0=Search, 1=SPC Updates, 2=Support
    }, 0);

    this.getDatabaseNews();
  }

  getDatabaseNews() {
    this.busyService.busy();

    this.datasearch.getDatabaseNews(this.databaseName).subscribe({
      next: (res: any) => {
        this.busyService.idle();

        const allNews = res?.data?.news || [];
        const database = res?.data?.database || {};

        // Store database ID for filtering categories
        this.databaseId = database._id || '';
        console.log('✅ Database Info:', {
          name: database.name,
          id: this.databaseId
        });
        console.log('✅ Database News:', allNews);

        if (!allNews.length) {
          console.warn('⚠️ No news found for ' + this.databaseName + ' database');
          return;
        }

        // Store all news
        this.newsList = allNews.map((news: any) => ({
          ...news,
          imgPath: this.filePath + (news.thumbnailImage || '')
        }));

        // Filter news with latestUpdate: true for recent news section
        this.recentNewsList = this.newsList
          .filter((news: any) => news.latestUpdate === true)
          .slice(0, 6);

        console.log('📰 Recent News (latestUpdate: true):', this.recentNewsList);

        // Get first 5 news for banner
        this.newsBannerData = this.newsList.slice(0, 5);

        // Extract unique category IDs from database_meta (filtered by databaseId)
        const categoryIds = this.extractUniqueCategoryIds(allNews, this.databaseId);
        console.log('📂 Extracted Category IDs (filtered by database):', categoryIds);

        // Fetch news by categories
        if (categoryIds.length > 0) {
          this.getNewsByCategoryList(categoryIds);
        } else {
          console.warn('⚠️ No categories found matching database ID:', this.databaseId);
        }

        this.showNews = true;
      },
      error: (err: any) => {
        this.busyService.idle();
        console.error('❌ Error fetching database news:', err);
      },
    });
  }

  extractUniqueCategoryIds(newsList: any[], databaseId: string): string[] {
    const categoryIdsSet = new Set<string>();

    console.log('🔍 Extracting categories from news list:', newsList.length, 'items');
    console.log('🔍 Filtering by database ID:', databaseId);

    newsList.forEach((news: any) => {
      if (news.database_meta && Array.isArray(news.database_meta)) {
        news.database_meta.forEach((meta: any) => {
          // Get database ID string (handle object or string)
          const metaDbId = (typeof meta.databaseId === 'object' && meta.databaseId?._id)
            ? meta.databaseId._id
            : meta.databaseId;

          // Only add category if databaseId matches (or if no databaseId provided to filter by)
          if (meta.category && (!databaseId || metaDbId === databaseId)) {
            const categoryId = (typeof meta.category === 'object' && meta.category?._id)
              ? meta.category._id
              : meta.category;

            if (categoryId) {
              categoryIdsSet.add(categoryId);
            }
          }
        });
      }
    });

    const categoryIds = Array.from(categoryIdsSet).slice(0, 5);
    console.log('📂 Final extracted category IDs (filtered):', categoryIds);

    if (categoryIds.length === 0 && newsList.length > 0) {
      console.warn('⚠️ No category IDs found in news metadata! All news items:', newsList);
    }

    return categoryIds;
  }

  getNewsByCategoryList(categoryIds: string[]) {
    if (categoryIds.length === 0) {
      console.warn('⚠️ No category IDs to fetch news for!');
      return;
    }

    this.busyService.busy();

    // Create array of observables for each category
    const newsRequests: Observable<any>[] = categoryIds.map((categoryId: string) => {
      return this.datasearch.getNewsByCategory(categoryId).pipe(
        catchError(err => {
          console.warn(`⚠️ Category ${categoryId} not found (404) - skipping`);
          // Return empty result so forkJoin doesn't fail completely
          return of({ data: { category: { name: '' }, news: [] }, _skip: true });
        })
      );
    });

    console.log(`📡 Making ${newsRequests.length} parallel API calls...`);

    // Fetch all category news in parallel
    forkJoin(newsRequests).subscribe({
      next: (responses: any[]) => {
        this.busyService.idle();
        this.newsCategoryData = {};

        responses.forEach((response: any, index: number) => {
          // Skip failed requests
          if (response?._skip) {
            return;
          }

          const categoryData = response?.data?.category || {};
          const newsData = response?.data?.news || [];
          
          // Get category name safely
          const categoryName = categoryData.name || response?.data?.news?.[0]?.category_meta?.name || `Category ${index + 1}`;

          console.log(`📂 Processing category: ${categoryName}`);
          console.log(`  Total news from API: ${newsData.length}`);

          // Filter news to only include items where database_meta contains current databaseId
          const filteredNews = newsData.filter((news: any) => {
            if (!this.databaseId) return true; // No filter if no databaseId

            if (news.database_meta && Array.isArray(news.database_meta)) {
              return news.database_meta.some((meta: any) => {
                const metaDbId = (typeof meta.databaseId === 'object' && meta.databaseId?._id)
                  ? meta.databaseId._id
                  : meta.databaseId;
                return metaDbId === this.databaseId;
              });
            }
            return false;
          });

          // Store up to 5 filtered news items per category
          if (filteredNews.length > 0) {
            this.newsCategoryData[categoryName] = filteredNews.slice(0, 5).map((news: any) => ({
              ...news,
              imgPath: this.filePath + (news.thumbnailImage || ''),
              categoryId: categoryIds[index]
            }));
          }
        });

        this.showCategory = true;
      },
      error: (err: any) => {
        this.busyService.idle();
        console.error('❌ Error fetching category news:', err);
        console.error('Error details:', {
          message: err.message,
          status: err.status,
          statusText: err.statusText,
          url: err.url
        });
      }
    });
  }

  ngAfterViewInit() {
    this.cdref.detectChanges();
  }

  receiveHeading(event: string) {
    this.heading = event;
    this.cdref.detectChanges();
  }

  receiveSidebarEvent(event: boolean) {
    this.toggle_sidebar = event;
    this.cdref.detectChanges();
  }
}
